import { contactBoxService } from 'services';
import { useDispatch } from 'react-redux';
import { addNotificationAction } from 'store/notifications/notificationsActions';
import { useTranslation } from 'react-i18next';
import { contactTypes } from 'shared/constants/contactBox';

export const useContact = ({ onSuccess, onError } = {}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return async ({ subject, message, origin, type, target }) => {
    try {
      const status = await contactBoxService({
        subject,
        message,
        origin,
        type,
        target,
      });

      if (status.ok) {
        dispatch(
          addNotificationAction({
            message: t(
              `${
                type === contactTypes.MESSAGE
                  ? 'Message was properly sent'
                  : 'Phone call request was successfully made'
              }`,
            ),
            variant: 'success',
          }),
        );
        if (onSuccess) {
          onSuccess();
        }
      } else {
        throw t('Something went wrong.');
      }
    } catch (error) {
      dispatch(
        addNotificationAction({
          message: t(
            `Failed to ${type === contactTypes.MESSAGE ? 'make a call request' : 'send a message'}`,
          ),
          variant: 'error',
        }),
      );
      if (onError) {
        onError();
      }
    }
  };
};
